import { Component, OnInit } from "@angular/core";
import { ThemeCustomizerService } from "../theme-customizer/theme-customizer.service";
import { AboutUsService } from "src/app/services/about-us.service";
import { AboutUsPages } from "src/app/models/aboutUs-pages.model";
import { environment } from "src/environments/environment.prod";



@Component({
    selector: 'app-about-page-one',
    templateUrl: './about-page-one.component.html',
})
export class AboutPageOneComponent implements OnInit {
    aboutUsPages: AboutUsPages | undefined;

    isToggled = false;

    constructor(
        private aboutUsService: AboutUsService,
        public themeService: ThemeCustomizerService
    ) {
        this.themeService.isToggled$.subscribe(isToggled => {
            this.isToggled = isToggled;
        });
    }

    toggleTheme() {
        this.themeService.toggleTheme();
    }

    createImgPath = (serverPath: string) => {
        if (serverPath)
            return `${environment.patchUrl}/${serverPath}`;
    }

    ngOnInit(): void {
        this.aboutUsService.getAll$().subscribe(x => {
            this.aboutUsPages = x.find(x => x.pageID == 1);
        });
    }
    getHeader_Img(): string | null {
        return localStorage.getItem('About');
    }

}